import { renderless, api } from "@opentiny/vue-renderless/button/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { iconLoading } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var classes = {
  "button": "inline-block sm:max-w-[9rem] text-center overflow-hidden overflow-ellipsis whitespace-nowrap transition-button duration-300 delay-[0ms]",
  "size-default": "h-10 text-sm sm:h-7 sm:text-xs",
  "size-medium": "h-10 text-sm sm:h-8 sm:text-xs",
  "size-small": "h-8 text-sm sm:h-7 sm:text-xs",
  "size-mini": "h-7 sm:h-6 sm:text-xs",
  "type-default": "text-black border-color-border hover:border-color-border-hover active:border-color-border-active sm:cursor-pointer",
  "type-primary": "text-white border-color-brand bg-color-brand hover:border-color-brand-hover hover:bg-color-brand-hover active:border-color-brand-active active:bg-color-brand-active sm:cursor-pointer",
  "type-success": "text-white border-color-success bg-color-success hover:border-color-success-hover hover:bg-color-success-hover active:border-color-success-active active:bg-color-success-active sm:cursor-pointer",
  "type-info": "text-white border-color-info-secondary bg-color-info-secondary hover:border-color-info-secondary-hover hover:bg-color-info-secondary-hover active:border-color-info-secondary-active active:bg-color-info-secondary-active sm:cursor-pointer",
  "type-warning": "text-white border-color-warning bg-color-warning hover:border-color-warning-hover hover:bg-color-warning-hover active:border-color-warning-active active:bg-color-warning-active sm:cursor-pointer",
  "type-danger": "text-white border-color-error bg-color-error hover:border-color-error-hover hover:bg-color-error-hover active:border-color-error-active active:bg-color-error-active sm:cursor-pointer",
  "type-text": "border-none bg-transparent cursor-pointer text-color-text-placeholder active:text-color-text-primary sm:hover:text-color-text-primary sm:active:!text-color-brand-active",
  "type-default-disabled": "text-color-text-disabled bg-color-bg-3 border-transparent hover:cursor-not-allowed",
  "type-primary-disabled": "text-white bg-color-brand-disabled border-transparent hover:cursor-not-allowed",
  "type-success-disabled": "text-white bg-color-success-disabled border-transparent hover:cursor-not-allowed",
  "type-info-disabled": "text-white bg-color-info-secondary-disabled border-transparent hover:cursor-not-allowed",
  "type-warning-disabled": "text-white bg-color-alert-disabled border-transparent hover:cursor-not-allowed",
  "type-danger-disabled": "text-white bg-color-error-disabled border-transparent hover:cursor-not-allowed",
  "type-text-disabled": "text-color-text-disabled hover:cursor-not-allowed",
  "type-default-plain": "text-black border-color-border hover:border-color-border-hover active:border-color-border-active sm:cursor-pointer",
  "type-primary-plain": "text-color-brand border-color-brand hover:text-color-brand-hover hover:border-color-brand-hover active:text-color-brand-active active:border-color-brand-active bg-white sm:cursor-pointer",
  "type-success-plain": "text-color-success border-color-success hover:text-color-success-hover hover:border-color-success-hover active:text-color-success-active active:border-color-success-active bg-white sm:cursor-pointer",
  "type-info-plain": "text-color-info-secondary border-color-info-secondary hover:text-color-info-secondary-hover hover:border-color-info-secondary-hover active:text-color-info-secondary-active active:border-color-info-secondary-active bg-white sm:cursor-pointer",
  "type-warning-plain": "text-color-warning border-color-warning hover:text-color-warning-hover hover:border-color-warning-hover active:text-color-warning-active active:border-color-warning-active bg-white sm:cursor-pointer",
  "type-danger-plain": "text-color-error border-color-error hover:text-color-error-hover hover:border-color-error-hover active:text-color-error-active active:border-color-error-active bg-white sm:cursor-pointer",
  "type-text-plain": "text-color-brand hover:text-color-brand-hover active:text-color-brand-active",
  "type-default-plain-disabled": "text-color-text-disabled bg-white border-color-text-disabled hover:cursor-not-allowed",
  "type-primary-plain-disabled": "text-color-brand-disabled bg-white border-color-brand-disabled hover:cursor-not-allowed",
  "type-success-plain-disabled": "text-color-success-disabled bg-white border-color-success-disabled hover:cursor-not-allowed",
  "type-info-plain-disabled": "text-color-info-secondary-disabled bg-white border-color-info-secondary-disabled hover:cursor-not-allowed",
  "type-warning-plain-disabled": "text-color-alert-disabled bg-white border-color-alert-disabled hover:cursor-not-allowed",
  "type-danger-plain-disabled": "text-color-error-disabled bg-white border-color-error-disabled hover:cursor-not-allowed",
  "type-text-plain-disabled": "text-color-text-disabled hover:cursor-not-allowed",
  "no-round": "rounded-sm",
  "is-round": "rounded-full",
  "is-border": "border-0.5 sm:border",
  "no-circle": "sm:min-w-[4.5rem] pl-3 pr-3",
  "is-circle": "sm:min-w-[0.4375rem] sm:rounded-full sm:pl-2 sm:pr-2",
  "button-icon": "-mt-0.5 sm:text-base fill-current",
  "button-icon-default": "text-color-icon-primary hover:text-color-icon-hover active:text-color-icon-active",
  "button-icon-disabled": "text-color-icon-disabled hover:cursor-not-allowed",
  "loading-svg": "animate-spin-2 mr-1 fill-current -inset-0.5",
  "button-link": "text-color-link hover:text-color-link-hover active:color-link-hover active:hover:text-color-link-hover sm:hover:text-color-link-hover"
};
var __vue2_script = defineComponent({
  inheritAttrs: false,
  emits: ["click"],
  props: [].concat(props, ["type", "text", "size", "icon", "resetTime", "nativeType", "loading", "disabled", "plain", "autofocus", "round", "circle", "tabindex", "href", "buttonClass"]),
  components: {
    IconLoading: iconLoading()
  },
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api,
      classes
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", _vm._b({
    class: _vm.m(_vm.gcls("button"), _vm.gcls("size-" + (_vm.size || "default")), _vm.gcls("type-" + (_vm.type || "default") + (_vm.icon ? "-icon" : _vm.state.plain ? "-plain" : "") + "\n        " + (_vm.state.buttonDisabled ? "-disabled" : "")), _vm.gcls(_vm.round ? "is-round" : "no-round"), _vm.gcls(_vm.circle ? "is-circle" : "no-circle"), _vm.gcls({
      "is-border": _vm.circle || !(_vm.type === "text" || _vm.icon)
    }), _vm.gcls({
      "button-link": _vm.href
    }), _vm.buttonClass),
    attrs: {
      "data-tag": "tiny-button",
      "disabled": _vm.state.buttonDisabled || _vm.loading,
      "autofocus": _vm.autofocus,
      "type": _vm.nativeType,
      "tabindex": _vm.tabindex
    },
    on: {
      "click": _vm.handleClick
    }
  }, "button", _vm.a(_vm.$attrs, ["class", "style"], true), false), [_vm.loading ? _c("icon-loading", {
    class: _vm.gcls("loading-svg")
  }) : _vm._e(), _vm.icon && !_vm.loading ? _c(_vm.icon, {
    tag: "component",
    class: [_vm.gcls("button-icon"), _vm.gcls("button-icon-" + (_vm.state.buttonDisabled ? "disabled" : "default"))]
  }) : _vm._e(), _vm._t("default", function() {
    return [_c("span", [_vm._v(_vm._s(_vm.text))])];
  })], 2);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
